// extracted by mini-css-extract-plugin
export default {"zoomControls":"Ica-z","zoomControlButton":"Jca-z","zoomBanner":"Kca-z","bannerButton":"Lca-z","imageButton":"Mca-z","zoom":"Nca-z","zoomContent":"Oca-z"};